import { getBatchItemSummaries } from '../apis/learn';
import { msDocs } from '../globals';
import { getMetas } from '../meta';

export async function getItemSummariesFromMetaTags() {
	return await Promise.all(getBatchItemSummaries(msDocs.data.userLocale, getMetas('learn_item')));
}
